import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import { format } from "date-fns";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import AddLinkIcon from "@mui/icons-material/AddLink";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PtsButton from "../buttons/PtsButton";
import PtsAlert from "../ptsAlert/PtsAlert";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Menu } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import FetchServerData from "../../../provider/FetchServerData";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import store from "../../../redux/store";
import infoIcon from "../../../assets/img/infoIcon.png";
import {
  CreateShort_URL,
  GetGroupActivityList_Url,
  GroupList_Url,
  SendQuickTextToGroupActivity_Url,
  SendSmsQuickText_Url,
  SmsActivityList_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
// import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import ActiveMenuAction from "../../../redux/activeMenu/ActiveMenuAction";
import ActivityContactList from "../activityContacts/ActivityContactList";
import GroupContactsDialog from "../activityContacts/GroupContactsDialog";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
import ShortLinkDialog from "../shortLink/ShortLinkDialog";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import AppUserDataAction from "../../../redux/appUserData/AppUserDataAction";
import SelectedDomainAction from "../../../redux/selectedDomain/SelectedDomainAction";
import PaginationRowAction from "../../../redux/paginationRow/PaginationRowAction";
import SelectedTabAction from "../../../redux/selectedTab/SelectedTabAction";

class QuickText extends Component {
  defaultCountry = store.getState().staticData.defaultCountry;
  countryListArray = store.getState().staticData.countryList;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  eventState = store.getState().businessDomain?.eventState;
  accountSettings = store.getState().accountSetting?.accountSetting;
  appuser = store.getState().appUserData.appUserData.appuser;
  paymentServiceType =
    store.getState().appUserData.appUserData.paymentServiceType;
  header = store.getState().header.header;
  organization = store.getState().appUserData?.organizationDetails;
  orgTimeZone = store.getState().appUserData?.organizationDetails?.timezone;
  eventTimeZone = store.getState().businessDomain?.eventTimeZone
  breadCrumb = [
    { pageid: "/messages", uiname: "Messages" },
    { pageid: "", uiname: "Send Quick Text" },
  ];

  constructor(props) {
    super(props);
    let smsVariableList = [];
    if (props.state) {
      smsVariableList = props.state.smsVariableList;
    }
    this.state = {
      smsVariableList: smsVariableList,
      textMessage: "",
      mobileNo: this.appuser?.phone !== null ? Utils.phoneNumberFormate(this.appuser.phone) : "",
      mobile: this.appuser?.phone !== null ? this.appuser.phone : "",
      countryCode: this.appuser?.phoneCountrycode !== null ? this.appuser.phoneCountrycode : "+1",
      shortlinkUrl: "",
      recipientType: null,
      cursorPosition: 0,
      smsGroupList: [],
      smsGroupsId: [],
      activitieIds: [],
      smsActivityList: [],
      recipientTypeList: [],
      sendToAllOptins: false,
      sendToAllPendings: false,
      avoidRepeatSend: false,
      isTextMessageLength: false,
      openTextingWindow: false,
      showPreviousMsg: false,
      showAllPreviousMsg: false,
      filterByKeyword: false,
      sortColumn: "name",
      sortDirection: "asc",
      sortMsgColumn: "messageName",
      sortMsgDirection: "asc",
      open: false,
      render: false,
      openTextingTimeWindow: false,
    };
  }

  componentDidMount() {
    this.GetGroupActivityList();
    // this.getSmsActivityList();
  }
  GetGroupActivityList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(GetGroupActivityList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          let smsActivityList = output.data.activityList;
          let recipientTypeList = output.data.recipientTypeList;
          // let recipientType = Utils.getArrayElement(recipientTypeList, 0);
          this.setState({
            // recipientType: recipientType,
            recipientTypeList: recipientTypeList,
            smsGroupList: smsGroupList,
            smsActivityList: smsActivityList,
          });
        } else {
        }
      }
    );
  }
  handleTextMessageChange(e) {
    let cursorPosition = e.target.selectionStart;
    let val = e.target.value;
    val = val?.replace(/—/g, "");
    if (this.accountSettings?.textMessageLength < Utils.countLetters(val)) {
      this.setState({
        cursorPosition: cursorPosition,
        textMessage: val,
        isTextMessageLength: true,
      });
    } else {
      this.setState({
        cursorPosition: cursorPosition,
        textMessage: val,
        isTextMessageLength: false,
      });
    }
  }

  handleTextMessageInsert(selectedValue) {
    const shouldInsertSpace =
      this.state.cursorPosition > 0 &&
      this.state.textMessage[this.state.cursorPosition - 1] !== " ";

    const newText =
      this.state.textMessage.substring(0, this.state.cursorPosition) +
      (shouldInsertSpace ? " " : "") +
      selectedValue.value +
      this.state.textMessage.substring(this.state.cursorPosition);

    this.setState(
      {
        textMessage: newText,
        cursorPosition:
          this.state.cursorPosition +
          selectedValue.value.length +
          (shouldInsertSpace ? 1 : 0),
      },
      () => {
        // Ensure cursor is placed correctly
        const input = document.getElementById("messageBox");
        if (input) {
          input.focus();
          input.setSelectionRange(
            this.state.cursorPosition,
            this.state.cursorPosition
          );
        }
      }
    );

    // this.setState({
    //   textMessage: `${this.state.textMessage.substring(0, this.state.cursorPosition)} ${
    //     selectedValue.value
    //   } ${this.state.textMessage.substring(this.state.cursorPosition)}`,
    // });
  }
  handleTextMessageShortlinkInsert() {
    this.setState({
      textMessage: `${this.state.textMessage} ${this.state.shortUrl}`,
    });
  }

  onCopy = (e) => {
    this.setState({ copied: true });
  };

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleAccountDropdownOpen = (e) => {
    // this.setState({ open: true, anchorEl: e.currentTarget });
    if (this.shortLinkDialogueRef && this.shortLinkDialogueRef.current) {
      this.shortLinkDialogueRef.current.showShortLinkList();
    }
  };

  handleShortlinkUrlChange(e) {
    this.setState({
      shortlinkUrl: e.target.value,
    });
  }

  createShortlinkToBackend() {
    const postObject = {
      header: this.header,
      url: this.state.shortlinkUrl,
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(CreateShort_URL, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let shortUrl = output.data.shortUrl;
          this.setState({
            shortUrl: shortUrl,
          });
        } else {
        }
      }
    );
  }
  sendQwickTextToBackend() {
    const timeZone =
      this.businessDomain === BUSINESS_DOMAIN.eventText
        ? this.eventTimeZone?.name
        : this.orgTimeZone?.name;

    const now = timeZone
      ? new Date(new Date().toLocaleString("en-US", { timeZone }))
      : new Date();

    if (this.isOutsideTextingWindow()) {
      this.setState({
        openTextingTimeWindow: true,
      });
      return;
    }

    if (this.eventState?.startDate) {
      const eventStart = timeZone
        ? new Date(
          new Date(this.eventState.startDate).toLocaleString("en-US", {
            timeZone,
          })
        )
        : new Date(this.eventState.startDate);

      if (eventStart > now) {
        this.setState({
          openTextingWindow: true,
        });
        return;
      }
    }

    if (!this.state.sendToAllOptins) {
      if (
        this.state.smsGroupsId.length === 0 &&
        this.state.activitieIds.length === 0 &&
        this.state.sendToAllOptins === false &&
        this.state.sendToAllPendings === false
      ) {
        PtsAlert.error("Please select the group");
        return;
      }
    }

    const postObject = {
      header: this.header,
      quickText: {
        textMessage: this.state.textMessage,
        // mobile: this.state.mobile,
        // countryCode: this.state.countryCode,
        event: {
          id: this.businessDomainId,
        },
      },
      groups: this.state.smsGroupsId,
      activities: this.state.activitieIds,
      // avoidRepeatSend: this.state.avoidRepeatSend,
      sendToAllOptins: this.state.sendToAllOptins,
      sendToAllPendings: this.state.sendToAllPendings,
      // recipientType: this.state.recipientType,
    };
    FetchServerData.callPostService(
      SendQuickTextToGroupActivity_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        PtsAlert.success(output.message);
        let smsCredits = output.data.smsCredits;
        store.dispatch(PaginationRowAction.setSendHistoryPaginationState({}));
        if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
          if (smsCredits !== null) {
            store.dispatch(
              SelectedDomainAction.setEventCreditUsage(smsCredits)
            );
          }
          store.dispatch(
            ActiveMenuAction.setActiveChildMenu("/eventSendHistory")
          );
          this.props.navigate("/eventSendHistory");
        } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
          if (smsCredits !== null) {
            store.dispatch(AppUserDataAction.setUsage(smsCredits));
          }
          store.dispatch(
            ActiveMenuAction.setActiveMenu("/dptextSendHistory")
          );
          this.props.navigate("/dptextSendHistory");
        } else {
          if (smsCredits !== null) {
            store.dispatch(AppUserDataAction.setUsage(smsCredits));
          }
          store.dispatch(ActiveMenuAction.setActiveMenu("/sendHistory"));
          this.props.navigate("/sendHistory");
        }
      } else {
      }
    });
  }

  SendTestQuickTextToBackend() {
    if (this.state.textMessage.length === 0 || this.state.textMessage.trim() === "") {
      PtsAlert.error("Please enter message text.");
      return;
    }

    if (!this.state.mobile || this.state.mobile.trim() === "") {
      PtsAlert.error("Please enter a mobile number.");
      return;
    }
    const postObject = {
      header: this.header,
      quickText: {
        textMessage: this.state.textMessage,
        mobile: this.state.mobile,
        countryCode: this.state.countryCode,
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService(SendSmsQuickText_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.setState({
            mobileNo: "",
            mobile: "",
            countryCode:
              this.defaultCountry !== null
                ? `+${this.defaultCountry?.phoneCode}`
                : "",
          });
          // if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
          //   store.dispatch(
          //     ActiveMenuAction.setActiveChildMenu("/eventSendHistory")
          //   );
          //   this.props.navigate("/eventSendHistory");
          // } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
          //   store.dispatch(
          //     ActiveMenuAction.setActiveMenu("/dptextSendHistory")
          //   );
          //   this.props.navigate("/dptextSendHistory");
          // } else {
          //   store.dispatch(ActiveMenuAction.setActiveMenu("/sendHistory"));
          //   this.props.navigate("/sendHistory");
          // }
        } else {
        }
      }
    );
  }

  handleSmsVariableOnDrag(e) {
    e.preventDefault();
    let smsVariable = e.target.innerHTML;
    this.setState((prevState) => ({
      textMessage: `${prevState.textMessage.substring(
        0,
        this.state.cursorPosition
      )} ${smsVariable} ${prevState.textMessage.substring(
        this.state.cursorPosition
      )}`,
      cursorPosition: `${prevState.textMessage.substring(
        0,
        this.state.cursorPosition
      )} ${smsVariable} ${prevState.textMessage.substring(
        this.state.cursorPosition
      )}`.length,
    }));
  }

  handleMobileNoChange(e) {
    let val = e.target.value;
    if (val.length <= 12) {
      let value = Utils.phoneNumberFormate(val);
      this.setState({
        mobileNo: value,
        mobile: e.target.value.replace(/-/g, ""),
      });
    }
  }

  handleCountryChange(phone, country, e, formattedValue) {
    this.setState({
      countryCode: formattedValue,
    });
  }

  onStatusClicked = (e, item) => {
    const isChecked = e.target.checked;

    this.setState((prevState) => {
      const updatedList = prevState.recipientTypeList.map((rec) =>
        rec.id === item.id
          ? { ...rec, isactive: isChecked }
          : rec
      );

      return {
        recipientTypeList: updatedList,
        sendToAllOptins: updatedList.find(r => r.type === "AllOptins")?.isactive || false,
        sendToAllPendings: updatedList.find(r => r.type === "AllPending")?.isactive || false,
      };
    });
  };

  onGroupClicked(e, groupId) {
    let smsGroupsId = this.state.smsGroupsId;
    if (e.target.checked) {
      this.setState({
        smsGroupsId: [...smsGroupsId, groupId],
      });
    } else {
      let index = smsGroupsId.indexOf(groupId);
      smsGroupsId.splice(index, 1);
      this.setState({
        smsGroupsId: smsGroupsId,
      });
    }
  }

  onActivityClicked(e, activityId) {
    let activitieId = this.state.activitieIds;
    if (e.target.checked) {
      this.setState({
        activitieIds: [...activitieId, activityId],
      });
    } else {
      let index = activitieId.indexOf(activityId);
      activitieId.splice(index, 1);
      this.setState({
        activitieIds: activitieId,
      });
    }
  }

  toActivityDetails(data) {
    if (
      this.activityContactDialogueRef &&
      this.activityContactDialogueRef.current
    ) {
      this.activityContactDialogueRef.current.showActivityContactList(data);
    }
  }

  toGroupDetails(data) {
    if (this.groupContactDialogueRef && this.groupContactDialogueRef.current) {
      this.groupContactDialogueRef.current.showGroupContactList(data);
    }
  }

  toByStatusDetails(data) {
    if (this.groupContactDialogueRef && this.groupContactDialogueRef.current) {
      if (data?.type === "AllPending") {
        this.groupContactDialogueRef.current.showAllPendingContactList();
      } else {
        this.groupContactDialogueRef.current.showAllOptinContactList();
      }
    }
  }

  handleRecipientTypeChange(selectedValue) {
    if (selectedValue.type === "AllOptins") {
      this.setState({
        recipientType: selectedValue,
        sendToAllOptins: true,
        smsGroupsId: [],
        activitieIds: [],
      });
    } else {
      this.setState({
        recipientType: selectedValue,
        sendToAllOptins: false,
      });
    }
  }

  avoidRepeatSendMessages(e) {
    this.setState({
      avoidRepeatSend: e.target.checked,
    });
  }

  viewCancel() {
    if (
      Utils.equalsIgnoreCase(this.businessDomain, BUSINESS_DOMAIN.eventText)
    ) {
      this.props.navigate("/eventMessages", {
        state: {
          action: "view",
          eventId: this.businessDomainId,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessages", {
        state: {
          action: "view",
          eventId: this.businessDomainId,
        },
      });
    } else {
      this.props.navigate("/messages");
    }
  }
  handleTextingWindowClose() {
    this.setState({
      openTextingWindow: false,
    });
  }

  getSmsGroupList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(GroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          this.setState({
            smsGroupList: smsGroupList,
          });
        } else {
        }
      }
    );
  }

  getSmsActivityList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(SmsActivityList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsActivityList = output.data.activityList;
          this.setState({
            smsActivityList: smsActivityList,
          });
        } else {
        }
      }
    );
  }

  togglePreviousMsg = () => {
    this.setState({ showPreviousMsg: !this.state.showPreviousMsg });
  };

  toggleShowAllPreviousMsg = () => {
    this.setState({ showAllPreviousMsg: !this.state.showAllPreviousMsg });
  };

  handleSort(column) {
    const { sortColumn, sortDirection, smsGroupList } = this.state;
    let newDirection = "asc";

    if (sortColumn === column && sortDirection === "asc") {
      newDirection = "desc";
    }

    // Copy array before sorting (to avoid mutating state directly)
    const sortedList = [...smsGroupList].sort((a, b) => {
      const valA = (a[column] || "").toString().toLowerCase();
      const valB = (b[column] || "").toString().toLowerCase();

      if (valA < valB) return newDirection === "asc" ? -1 : 1;
      if (valA > valB) return newDirection === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      smsGroupList: sortedList,
      sortColumn: column,
      sortDirection: newDirection,
    });
  }

  handleSortActivityList(column) {
    const { sortMsgColumn, sortMsgDirection, smsActivityList } = this.state;
    let newDirection = "asc";

    if (sortMsgColumn === column && sortMsgDirection === "asc") {
      newDirection = "desc";
    }

    // Copy array before sorting (to avoid mutating state directly)
    const sortedList = [...smsActivityList].sort((a, b) => {
      const valA = (a[column] || "").toString().toLowerCase();
      const valB = (b[column] || "").toString().toLowerCase();

      if (valA < valB) return newDirection === "asc" ? -1 : 1;
      if (valA > valB) return newDirection === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      smsActivityList: sortedList,
      sortMsgColumn: column,
      sortMsgDirection: newDirection,
    });
  }

  isSendDisabled = () => {
    return (
      (this.state.smsGroupsId.length === 0 &&
        this.state.activitieIds.length === 0 &&
        this.state.sendToAllPendings === false &&
        this.state.sendToAllOptins === false) || this.state.textMessage.length === 0
    );
  };

  handleTextingTimeWindowClose() {
    this.setState({
      openTextingTimeWindow: false,
    });
  }

  organizationInfo() {
    this.setState({
      openTextingTimeWindow: false,
    });
    store.dispatch(ActiveMenuAction.setActiveMenu("/settings"));
    store.dispatch(SelectedTabAction.setSelectedTab(0));

    this.props.navigate("/settings", {
      state: {
        pageId: "OrgLogo",
        action: "view",
      },
    });
  }


  isOutsideTextingWindow = () => {
    const startStr = this.organization?.textingWindowStart;
    const endStr = this.organization?.textingWindowEnd;
    const timeZone = this.businessDomain === BUSINESS_DOMAIN.eventText ? this.eventTimeZone?.name : this.orgTimeZone?.name; // e.g. "Asia/Kolkata"

    if (!startStr || !endStr) return false;

    const now = timeZone
      ? new Date(new Date().toLocaleString("en-US", { timeZone }))
      : new Date();

    const [startH, startM, startS] = startStr?.split(":").map(Number);
    const [endH, endM, endS] = endStr?.split(":").map(Number);

    const start = new Date(now);
    start.setHours(startH, startM, startS, 0);

    const end = new Date(now);
    end.setHours(endH, endM, endS, 0);

    if (start <= end) {
      return now < start || now > end;
    }

    return !(now >= start || now <= end);
  };

  render() {
    this.shortLinkDialogueRef = React.createRef();
    this.activityContactDialogueRef = React.createRef();
    this.groupContactDialogueRef = React.createRef();
    const validCountryCodes = this.countryListArray
      ?.filter((country) => ["US", "CA", "AU", "IN"].includes(country.code))
      .map((country) => country.code.toLowerCase());
    const enableCountryCode = process.env.REACT_APP_ENABLE_COUNTRYCODE === "true";
    return (
      <>
        <MenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          backCallback={this.viewCancel.bind(this)}
          domainObject="Quick Text"
          name="Quick Text - Send a text message without saving it to the main Message List."
        />
        <ShortLinkDialog
          ref={this.shortLinkDialogueRef}
          style={{ float: "right" }}
        />
        <ActivityContactList
          ref={this.activityContactDialogueRef}
          style={{ float: "right" }}
          onChange={this.getSmsActivityList.bind(this)}
        />
        <GroupContactsDialog
          ref={this.groupContactDialogueRef}
          style={{ float: "right" }}
          onChange={this.getSmsGroupList.bind(this)}
        />
        <div className="row" style={{ marginTop: "1em" }}>
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.sendQwickTextToBackend.bind(this)}
          >
            <div className="col-md-12">
              <div className="card" id="giveBeeCard">
                <div className="card-body p-0">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <label
                          htmlFor="exampleFormControlTextarea1"
                          className="col-sm-2 col-form-label fw-bold pe-0"
                        >
                          Text Message*
                          <Tooltip
                            arrow
                            placement="top"
                            title="This message is sent to the recipents."
                            classes={{ popper: "custom-tooltip" }}
                          >
                            <img src={infoIcon} alt="" width="20" height="20" />
                          </Tooltip>
                        </label>
                        <div className="col-md-4 pt-2">
                          <textarea
                            required
                            autoFocus={true}
                            value={this.state.textMessage}
                            onChange={this.handleTextMessageChange.bind(this)}
                            onBlur={this.handleTextMessageChange.bind(this)}
                            className="form-control"
                            id="messageBox"
                            rows="3"
                            style={{
                              overflow: "hidden",
                              resize: "vertical",
                            }}
                          />
                          {this.accountSettings?.textMessageLength <
                            Utils.countLetters(this.state.textMessage) && (
                              <span
                                className="danger ms-2"
                                style={{ color: "red", fontSize: "14px" }}
                              >
                                The size of this field is limited to{" "}
                                {this.accountSettings?.textMessageLength}{" "}
                                characters only.
                              </span>
                            )}
                          <span
                            style={{
                              fontSize: "14px",
                              float: "right",
                            }}
                          >
                            {Utils.trimLetters(this.state.textMessage)}
                            /{this.accountSettings?.textMessageLength}
                          </span>
                        </div>
                        <div className="col-md-3 pt-2">
                          <ul className="p-0" style={{ listStyle: "none" }}>
                            {this.state.smsVariableList?.map((data, index) => {
                              return (
                                <>
                                  {data?.name === "FirstName" ?
                                    <Tooltip
                                      title={`Alternate: ${this.organization?.firstNameAlternateValue !== null ? this.organization?.firstNameAlternateValue : ""}`}
                                      arrow
                                      classes={{ popper: "alternateCustom-tooltip" }}
                                      placement="right"
                                    >
                                      <li
                                        className="d-flex mt-1 variableButton"
                                        onClick={this.handleTextMessageInsert.bind(
                                          this,
                                          data
                                        )}
                                      >
                                        {data.name === "FirstName" && (
                                          <IconButton className="pe-1">
                                            <ChatBubbleOutlineIcon
                                              style={{
                                                fontSize: "16px",
                                                width: "25px",
                                              }}
                                            />
                                          </IconButton>
                                        )}
                                        {data.name === "EventName" && (
                                          <IconButton className="pe-1">
                                            <i
                                              class="fa fa-plus"
                                              aria-hidden="true"
                                              style={{
                                                fontSize: "16px",
                                                width: "25px",
                                              }}
                                            ></i>
                                          </IconButton>
                                        )}
                                        {data.name === "EventStartDate" && (
                                          <IconButton className="pe-1">
                                            <i
                                              class="fa fa-calendar-plus-o"
                                              aria-hidden="true"
                                              style={{
                                                fontSize: "15px",
                                                width: "25px",
                                              }}
                                            ></i>
                                          </IconButton>
                                        )}
                                        {data.name === "EventEndDate" && (
                                          <IconButton className="pe-1">
                                            <i
                                              class="fa fa-calendar-plus-o"
                                              aria-hidden="true"
                                              style={{
                                                fontSize: "15px",
                                                width: "25px",
                                              }}
                                            ></i>
                                          </IconButton>
                                        )}
                                        {data.name === "PaymentLink" && (
                                          <IconButton className="pe-1">
                                            <i
                                              class="fa fa-usd"
                                              aria-hidden="true"
                                              style={{
                                                fontSize: "16px",
                                                width: "25px",
                                              }}
                                            ></i>
                                          </IconButton>
                                        )}
                                        <span
                                          style={{
                                            cursor: "pointer",
                                          }}
                                          key={index}
                                          draggable
                                        >
                                          {data.description}
                                        </span>
                                      </li>
                                    </Tooltip>
                                    :
                                    <li
                                      className="d-flex mt-1 variableButton"
                                      onClick={this.handleTextMessageInsert.bind(
                                        this,
                                        data
                                      )}
                                    >
                                      {data.name === "FirstName" && (
                                        <IconButton className="pe-1">
                                          <ChatBubbleOutlineIcon
                                            style={{
                                              fontSize: "16px",
                                              width: "25px",
                                            }}
                                          />
                                        </IconButton>
                                      )}
                                      {data.name === "EventName" && (
                                        <IconButton className="pe-1">
                                          <i
                                            class="fa fa-plus"
                                            aria-hidden="true"
                                            style={{
                                              fontSize: "16px",
                                              width: "25px",
                                            }}
                                          ></i>
                                        </IconButton>
                                      )}
                                      {data.name === "EventStartDate" && (
                                        <IconButton className="pe-1">
                                          <i
                                            class="fa fa-calendar-plus-o"
                                            aria-hidden="true"
                                            style={{
                                              fontSize: "15px",
                                              width: "25px",
                                            }}
                                          ></i>
                                        </IconButton>
                                      )}
                                      {data.name === "EventEndDate" && (
                                        <IconButton className="pe-1">
                                          <i
                                            class="fa fa-calendar-plus-o"
                                            aria-hidden="true"
                                            style={{
                                              fontSize: "15px",
                                              width: "25px",
                                            }}
                                          ></i>
                                        </IconButton>
                                      )}
                                      {data.name === "PaymentLink" && (
                                        <IconButton className="pe-1">
                                          <i
                                            class="fa fa-usd"
                                            aria-hidden="true"
                                            style={{
                                              fontSize: "16px",
                                              width: "25px",
                                            }}
                                          ></i>
                                        </IconButton>
                                      )}
                                      <span
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        key={index}
                                        draggable
                                      >
                                        {data.description}
                                      </span>
                                    </li>
                                  }
                                </>
                              );
                            })}
                            <li
                              className="mt-1 variableButton"
                              onClick={this.handleAccountDropdownOpen.bind(
                                this
                              )}
                            >
                              <IconButton
                                className="pe-1"
                                style={{ height: "15px" }}
                              >
                                <AddLinkIcon
                                  style={{
                                    fontSize: "20px",
                                    width: "25px",
                                  }}
                                />
                              </IconButton>
                              <span>Insert Short Link</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <Menu
                      anchorEl={this.state.anchorEl}
                      id="dropdown-menu"
                      className="filterDropdownMenu"
                      open={this.state.open}
                      onClose={this.handleAccountDropdownClose}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: "visible",
                          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                          mt: 1.5,
                          "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                          },
                          "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 20,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: "right", vertical: "top" }}
                      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    >
                      <IconButton
                        aria-label="close"
                        onClick={this.handleAccountDropdownClose.bind(this)}
                        style={{
                          position: "absolute",
                          right: 8,
                          top: 4,
                          color: (theme) => theme.palette.grey[500],
                        }}
                      >
                        <CloseIcon
                          style={{
                            color: "#000",
                            fontWeight: "600",
                          }}
                        />
                      </IconButton>
                      <div
                        className="dropdown-item"
                        style={{
                          cursor: "pointer",
                          width: "500px",
                          height: "100%",
                        }}
                      >
                        <div className="row mt-2">
                          <div className="col-md-9 mt-1" id="assetFormLabel">
                            <label
                              className="form-label "
                              htmlFor="collapsible-supplierType"
                            >
                              Create Short Link
                            </label>
                            <input
                              type="link"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              value={this.state.shortlinkUrl}
                              onChange={this.handleShortlinkUrlChange.bind(
                                this
                              )}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginTop: "32px" }}
                          >
                            <PtsButton
                              btnName="Shorten"
                              onClick={this.createShortlinkToBackend.bind(this)}
                            />
                          </div>
                        </div>
                        {this.state.shortUrl && (
                          <div className="row mt-4">
                            <div className="col-md-12">
                              <span
                                className="ms-2"
                              // onClick={this.handleTextMessageShortlinkInsert.bind(
                              //   this
                              // )}
                              >
                                <a
                                  href={this.state.shortUrl}
                                  target="_blank"
                                  className="anchortag mt-4"
                                  rel="noopener noreferrer"
                                  style={{ width: "220px", color: "#5faee3" }}
                                >
                                  {this.state.shortUrl}
                                </a>{" "}
                                &nbsp;
                                <Tooltip
                                  title="Copy to clipboard"
                                  aria-label="add"
                                  classes={{ popper: "custom-tooltip" }}
                                >
                                  <IconButton>
                                    <CopyToClipboard
                                      text={this.state.shortUrl}
                                      onClick={this.onCopy}
                                    >
                                      <FileCopyIcon
                                        style={{
                                          color: "gray",
                                          fontSize: "20px",
                                        }}
                                      />
                                    </CopyToClipboard>
                                  </IconButton>
                                </Tooltip>
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                    </Menu>
                  </div>
                  <div className="row mb-3 mt-2">
                    <div className="col-md-12">
                      <div className="row">
                        <label
                          htmlFor="exampleFormControlTextarea1"
                          className="col-sm-2 col-form-label fw-bold"
                        >
                          Test it now
                        </label>
                        <div className="col-sm-3 m-0" id="givbeeText">
                          {enableCountryCode ?
                            <span className="d-flex">
                              <PhoneInput
                                country={this.defaultCountry?.code
                                  ?.toString()
                                  .toLowerCase()}
                                onlyCountries={validCountryCodes}
                                value={this.state.countryCode}
                                onChange={(phone, country, e, formattedValue) => {
                                  this.handleCountryChange(
                                    phone,
                                    country,
                                    e,
                                    formattedValue
                                  );
                                }}
                                autoFormat
                                countryCodeEditable={false}
                                disableCountryGuess={false}
                                enableSearch={true}
                                alwaysDefaultMask={true}
                              />
                              <input
                                type="text"
                                autoComplete="off"
                                id="multiStepsFirstName"
                                name="multiStepsFirstName"
                                className="form-control"
                                value={this.state.mobileNo}
                                onChange={this.handleMobileNoChange.bind(this)}
                                validators={["required"]}
                                errormessages={["This field is required"]}
                              />
                            </span>
                            :
                            <input
                              type="text"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              value={this.state.mobileNo}
                              onChange={this.handleMobileNoChange.bind(this)}
                              validators={["required"]}
                              errormessages={["This field is required"]}
                            />
                          }
                        </div>
                        <div className="col-md-2 align-self-center">
                          {this.state.isTextMessageLength ? (
                            <Button
                              id="ptsButton"
                              type="button"
                              variant="contained"
                              disabled
                              style={{ width: "100px" }}
                              className="btn addBtn mb-1"
                              onClick={this.SendTestQuickTextToBackend.bind(
                                this
                              )}
                            >
                              Send Test
                            </Button>
                          ) : (
                            <Button
                              id="ptsButton"
                              type="button"
                              variant="contained"
                              style={{ width: "100px" }}
                              className="btn addBtn mb-1"
                              onClick={this.SendTestQuickTextToBackend.bind(
                                this
                              )}
                            >
                              Send Test
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />

                  <div className="p-3 pt-1">
                    <div className="col-md-12">
                      <div className="row d-flex">
                        <label
                          className="col-sm-2 col-form-label fw-bold ps-0"
                          htmlFor="basic-default-supplierType"
                          id="assetFormLabel"
                        >
                          Select
                          <p
                            className="fw-normal ps-0 m-0 pe-4"
                            htmlFor="basic-default-supplierType"
                            id="givbeeText"
                            style={{ fontSize: "12px" }}
                          >
                            Messages are sent to selected recipients just once.
                          </p>
                        </label>
                        <div className="col-sm-10">
                          <div className="row d-flex">
                            <div className="col-sm-12">
                              <div className="row d-flex pb-2 pb-2">
                                <label
                                  className="col-sm-2 col-form-label fw-bold ps-1"
                                  htmlFor="exampleFormControlTextarea1"
                                >
                                  By Status
                                </label>
                                <div className="col-md-10">
                                  <div className="row d-flex pt-1">
                                    {this.state.recipientTypeList?.map(
                                      (item, index) =>
                                        item.count > 0 ? (
                                          <li
                                            className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                            style={{ width: "22em" }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={item.isactive}
                                              id={`checkboxByStatus-${item.id}`}
                                              onChange={(e) =>
                                                this.onStatusClicked(e, item)
                                              }
                                              style={{
                                                alignSelf: "center",
                                                marginRight: 5,
                                                marginTop: "1px",
                                                height: "12px",
                                                width: "12px",
                                              }}
                                            />
                                            &nbsp;
                                            <span
                                              style={{
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                document
                                                  .getElementById(
                                                    `checkboxByStatus-${item.id}`
                                                  )
                                                  .click()
                                              }
                                            >
                                              {item?.description}
                                            </span>
                                            <span
                                              className="ms-2"
                                              style={{
                                                cursor: "pointer",
                                                color: "#337AB7",
                                                fontWeight: "600",
                                              }}
                                              onClick={this.toByStatusDetails.bind(
                                                this,
                                                item
                                              )}
                                            >
                                              {"(" + item.count + ")"}
                                            </span>
                                          </li>
                                        ) : (
                                          <li
                                            className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                            style={{
                                              width: "22em",
                                              color: "#cccccc",
                                            }}
                                          >
                                            <input
                                              disabled
                                              type="checkbox"
                                              checked={item.isactive}
                                              style={{
                                                alignSelf: "center",
                                                marginRight: 5,
                                                marginTop: "1px",
                                                height: "12px",
                                                width: "12px",
                                              }}
                                            />
                                            &nbsp;
                                            <span
                                              style={{
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              }}
                                            >
                                              {item?.description}
                                            </span>
                                            <span
                                              className="ms-2"
                                              style={{
                                                color: "#cccccc",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {"(" + item.count + ")"}
                                            </span>
                                          </li>
                                        )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row d-flex">
                            <div className="col-md-12">
                              <>
                                <div
                                  className="row d-flex pt-2 pb-2"
                                  style={{
                                    borderTop: "2px solid #d3d0d0d5",
                                  }}
                                >
                                  <label
                                    className="col-sm-2 col-form-label fw-bold ps-1"
                                    htmlFor="exampleFormControlTextarea1"
                                  >
                                    <span
                                      className="cursor-pointer"
                                      onClick={() => this.handleSort("name")}
                                    >
                                      By Group
                                      {this.state.sortColumn === "name" &&
                                        (this.state.sortDirection === "asc" ? (
                                          <i
                                            class="fa fa-long-arrow-up ps-1"
                                            aria-hidden="true"
                                          ></i>
                                        ) : (
                                          <i class="fa-solid fa-arrow-down-long ps-1"></i>
                                        ))}
                                    </span>
                                  </label>
                                  <div className="col-md-10 ps-0">
                                    <div className="pt-1 prev-container">
                                      {this.state.smsGroupList?.map((item) =>
                                        item.count > 0 ? (
                                          <li
                                            key={item.id}
                                            className="list-group-item border-0 prev pt-0 pb-0 d-flex"
                                            style={{
                                              width: "22em",
                                              breakInside: "avoid",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              checked={item.isactive}
                                              id={`checkbox-${item.id}`}
                                              onChange={(e) => this.onGroupClicked(e, item.id)}
                                              style={{
                                                alignSelf: "center",
                                                marginRight: 5,
                                                marginTop: "1px",
                                                height: "12px",
                                                width: "12px",
                                              }}
                                            />

                                            <span
                                              style={{
                                                display: "inline-block",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                cursor: "pointer",
                                                color: this.state.smsGroupsId?.includes(item.id)
                                                  ? "#337AB7"
                                                  : "#697a8d",
                                              }}
                                              onClick={() =>
                                                document
                                                  .getElementById(`checkbox-${item.id}`)
                                                  .click()
                                              }
                                            >
                                              {item?.name}
                                            </span>

                                            <span
                                              className="ms-2"
                                              style={{
                                                cursor: "pointer",
                                                color: this.state.smsGroupsId?.includes(item.id)
                                                  ? "#337AB7"
                                                  : "#697a8d",
                                                fontWeight: "600",
                                              }}
                                              onClick={() => this.toGroupDetails(item)}
                                            >
                                              {"(" + item.count + ")"}
                                            </span>
                                          </li>
                                        ) : null
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {this.state.smsActivityList.length > 0 && (
                                  <div
                                    className="row d-flex pt-2"
                                    style={{
                                      borderTop: "2px solid #d3d0d0d5",
                                    }}
                                  >
                                    {/* Header with Expand/Collapse */}

                                    <label
                                      className="col-sm-2 col-form-label fw-bold d-flex flex-column align-self-start ps-1 pe-0"
                                      htmlFor="exampleFormControlTextarea1"
                                    >
                                      <div className="d-flex align-items-center">
                                        <span
                                          className="cursor-pointer"
                                          onClick={() =>
                                            this.handleSortActivityList(
                                              "messageName"
                                            )
                                          }
                                        >
                                          By Previous Msg
                                          {(this.state.sortMsgColumn ===
                                            "messageName" && this.state.showPreviousMsg) &&
                                            (this.state
                                              .sortMsgDirection ===
                                              "asc" ? (
                                              <i
                                                className="fa fa-long-arrow-up ps-1"
                                                aria-hidden="true"
                                              ></i>
                                            ) : (
                                              <i className="fa-solid fa-arrow-down-long ps-1"></i>
                                            ))}
                                        </span>

                                        <IconButton
                                          className="cursor-pointer"
                                          size="small"
                                          onClick={this.togglePreviousMsg}
                                          style={{ marginLeft: "4px" }}
                                        >
                                          {this.state.showPreviousMsg ? (
                                            <ExpandLess fontSize="small" />
                                          ) : (
                                            <ExpandMore fontSize="small" />
                                          )}
                                        </IconButton>
                                      </div>
                                      {this.state.showPreviousMsg && (
                                        <div className="mt-2 d-flex align-items-center">
                                          <input
                                            type="checkbox"
                                            style={{ cursor: "pointer" }}
                                            checked={
                                              this.state.filterByKeyword
                                            }
                                            onChange={() =>
                                              this.setState({
                                                filterByKeyword:
                                                  !this.state
                                                    .filterByKeyword,
                                              })
                                            }
                                          />
                                          <p
                                            className="form-label mb-0 ms-2 fw-normal"
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.setState({
                                                filterByKeyword:
                                                  !this.state
                                                    .filterByKeyword,
                                              })
                                            }
                                          >
                                            By Keyword
                                          </p>
                                        </div>
                                      )}
                                    </label>
                                    {/* Collapsible Section */}
                                    {this.state.showPreviousMsg && (
                                      <div className="col-md-10 ps-0">
                                        <div className="pt-1 prev-container">
                                          {(this.state.filterByKeyword
                                            ? this.state.smsActivityList?.filter(
                                              (x) => x.messageKeyword !== ""
                                            )
                                            : this.state.smsActivityList
                                          )?.map((item) => {
                                            const itemLabel = this.state.filterByKeyword
                                              ? `${item.messageKeyword} (${item.messageName})`
                                              : `${item.messageName} ${item.messageKeyword ? `(${item.messageKeyword})` : ""
                                              }`;

                                            const isActive = this.state.activitieIds?.includes(item.id);

                                            if (!this.state.filterByKeyword && item.activeContacts <= 0) {
                                              return (
                                                <li
                                                  key={item.id}
                                                  className="list-group-item border-0 prev pt-0 pb-0 d-flex"
                                                  style={{
                                                    width: "100%",
                                                    breakInside: "avoid",
                                                    color: "#cccccc",
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    checked={item.isactive}
                                                    disabled
                                                    style={{
                                                      alignSelf: "center",
                                                      marginRight: 5,
                                                      marginTop: "1px",
                                                      height: "12px",
                                                      width: "12px",
                                                    }}
                                                  />

                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      whiteSpace: "nowrap",
                                                      overflow: "hidden",
                                                      textOverflow: "ellipsis",
                                                    }}
                                                  >
                                                    {itemLabel}
                                                  </span>

                                                  <span
                                                    className="ms-2"
                                                    style={{
                                                      color: "#cccccc",
                                                      fontWeight: "600",
                                                    }}
                                                  >
                                                    ({item.activeContacts})
                                                  </span>
                                                </li>
                                              );
                                            }

                                            return (
                                              <Tooltip
                                                arrow
                                                key={item.id}
                                                title={
                                                  item.messageKeyword !== ""
                                                    ? `Keyword: ${item.messageKeyword}`
                                                    : ""
                                                }
                                                classes={{
                                                  popper: "custom-tooltip",
                                                }}
                                              >
                                                <li
                                                  className="list-group-item list-group-item-action border-0 prev pt-0 pb-0 d-flex"
                                                  style={{
                                                    width: "100%",
                                                    breakInside: "avoid",
                                                  }}
                                                >
                                                  <input
                                                    type="checkbox"
                                                    checked={item.isactive}
                                                    id={`checkbox-${item.id}`}
                                                    onChange={(e) =>
                                                      this.onActivityClicked(e, item.id)
                                                    }
                                                    style={{
                                                      alignSelf: "center",
                                                      marginRight: 5,
                                                      marginTop: "1px",
                                                      height: "12px",
                                                      width: "12px",
                                                    }}
                                                  />

                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      whiteSpace: "nowrap",
                                                      overflow: "hidden",
                                                      textOverflow: "ellipsis",
                                                      cursor: "pointer",
                                                      color: isActive ? "#337AB7" : "#697a8d",
                                                    }}
                                                    onClick={() =>
                                                      document
                                                        .getElementById(`checkbox-${item.id}`)
                                                        .click()
                                                    }
                                                  >
                                                    {itemLabel}
                                                  </span>

                                                  <span
                                                    className="ms-2"
                                                    style={{
                                                      cursor: "pointer",
                                                      color: isActive ? "#337AB7" : "#697a8d",
                                                      fontWeight: "600",
                                                    }}
                                                    onClick={() =>
                                                      this.toActivityDetails(item)
                                                    }
                                                  >
                                                    ({item.activeContacts})
                                                  </span>
                                                </li>
                                              </Tooltip>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-sm-12 mt-3 text-center">
                  {this.state.isTextMessageLength ? (
                    <Button
                      className="btn addBtn btn-primary me-4"
                      disabled
                      type="submit"
                      style={{
                        padding: "10px",
                        // background: "#37517e",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: "600",
                        width: "80px",
                        textTransform: "capitalize",
                      }}
                    >
                      Send
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      type="submit"
                      disabled={this.isSendDisabled()}
                      style={{
                        padding: "10px",
                        background: "#37517e",
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: "600",
                        width: "80px",
                        textTransform: "capitalize",
                        opacity: this.isSendDisabled() ? 0.6 : 1,
                        cursor: this.isSendDisabled() ? "not-allowed" : "pointer",
                      }}
                    >
                      Send
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </ValidatorForm >
        </div >
        <Dialog
          open={this.state.openTextingWindow}
          onClose={this.handleTextingWindowClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <span style={{ textAlign: "center" }}>
              <p className="m-0" style={{ fontSize: "16px" }}>
                Your texting window starts on{" "}
                <b>{this.eventState?.startDate}</b>. You can test by using SEND
                TEST till then.
              </p>
            </span>
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.openTextingTimeWindow}
          onClose={this.handleTextingTimeWindowClose.bind(this)}
          style={{ padding: "1em" }}
        >
          <DialogContent>
            <span style={{ textAlign: "center" }}>
              <p style={{ fontSize: "16px" }}>
                {`Texts can only be sent between the hours of ${Utils.formatTimeToAMPM(this.organization?.textingWindowStart)} and ${Utils.formatTimeToAMPM(this.organization?.textingWindowEnd)}. In the case of an emergency, you may`}
                <span
                  className="anchortag ps-1"
                  onClick={() => this.organizationInfo()}
                >
                  override the setting here.
                </span>
              </p>
            </span>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default withRouter(QuickText);
